<template>
  <footer class="bg-white text-gray-800 pt-36 pb-6 px-6">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-10">
      <div class="space-y-4 md:col-span-2">
        <div class="space-y-4">
          <h4 class="font-semibold text-sm">Follow us</h4>
          <div class="flex gap-4 text-xl">
            <a
              href="https://facebook.com"
              target="_blank"
              class="hover:text-blue-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-3h2.5v-2.3c0-2.5 1.5-3.9 3.7-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.3c-1.3 0-1.7.8-1.7 1.6V12h2.9l-.5 3h-2.4v7A10 10 0 0 0 22 12z"
                />
              </svg>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              class="hover:text-pink-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 2 .2 2.4.4.6.2 1.1.5 1.6.9.4.4.7.9.9 1.6.2.4.3 1.2.4 2.4.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 2-.4 2.4a3.7 3.7 0 0 1-.9 1.6c-.4.4-.9.7-1.6.9-.4.2-1.2.3-2.4.4-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-2-.2-2.4-.4a3.7 3.7 0 0 1-1.6-.9 3.7 3.7 0 0 1-.9-1.6c-.2-.4-.3-1.2-.4-2.4-.1-1.2-.1-1.6-.1-4.8s0-3.6.1-4.8c.1-1.2.2-2 .4-2.4.2-.6.5-1.1.9-1.6.4-.4.9-.7 1.6-.9.4-.2 1.2-.3 2.4-.4 1.2-.1 1.6-.1 4.8-.1zm0 1.8c-3.1 0-3.4 0-4.6.1-1.1.1-1.7.2-2.1.4a2 2 0 0 0-.8.5c-.3.3-.5.5-.7.8-.2.4-.3 1-.4 2.1-.1 1.2-.1 1.5-.1 4.6s0 3.4.1 4.6c.1 1.1.2 1.7.4 2.1.2.3.4.6.7.8.3.3.5.5.8.7.4.2 1 .3 2.1.4 1.2.1 1.5.1 4.6.1s3.4 0 4.6-.1c1.1-.1 1.7-.2 2.1-.4a2 2 0 0 0 .8-.5c.3-.3.5-.5.7-.8.2-.4.3-1 .4-2.1.1-1.2.1-1.5.1-4.6s0-3.4-.1-4.6c-.1-1.1-.2-1.7-.4-2.1a2 2 0 0 0-.5-.8c-.3-.3-.5-.5-.8-.7-.4-.2-1-.3-2.1-.4-1.2-.1-1.5-.1-4.6-.1zm0 3.3a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zm0 10.7a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4zm5.4-10.9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                />
              </svg>
            </a>
          </div>
        </div>

        <div class="space-y-2 text-sm mt-6">
          <div class="flex items-center gap-2">📞 soon</div>
          <div class="flex items-center gap-2">
            ✉️ contact@interactivemedicalfacilities.com
          </div>
          <div class="flex items-start gap-2">
            📍 14/F Manila Astral Tower Taft Ave, cor Padre Faura St, Manila.
          </div>
        </div>
      </div>

      <div class="space-y-2">
        <h4 class="font-semibold">Company</h4>
        <ul class="space-y-1 text-sm">
          <li><a href="#" class="hover:underline">About us</a></li>
          <li>
            <a href="#" class="hover:underline">Our Teams</a>
          </li>
          <li><a href="#" class="hover:underline">Our Doctors</a></li>
        </ul>
      </div>

      <div class="space-y-2">
        <h4 class="font-semibold">Partner</h4>
        <ul class="space-y-1 text-sm">
          <li>
            <a
              href="https://iwc.com.ph/"
              target="_blank"
              class="hover:underline"
              >IMS Wellth Care, Inc.</a
            >
          </li>
          <li v-show="false">
            <a href="#" class="hover:underline"
              >Integrated Management Services</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div
      class="border-t mt-12 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 gap-4"
    >
      <p>©2025 Developed by Alvin Vergara</p>
      <div class="flex flex-wrap gap-4">
        <router-link to="/termsandconditions" class="hover:underline"
          >Terms & Conditions</router-link
        >
        <router-link to="/privacypolicy" href="#" class="hover:underline"
          >Privacy Policy</router-link
        >
      </div>
    </div>
  </footer>
</template>
